export enum TASK_OVERVIEW_STATUSES {
    Completed = "completed",
    CompletedWithErrors = "completed_with_errors",
    Failed = "failed",
    NoTasks = "no tasks"
}

export enum TIMEFRAMES {
    TaskCount7Days = "task_type_counts_7_days",
    TaskCount30Days = "task_type_counts_30_days",
    TaskCount90Days = "task_type_counts_90_days"
}
